<script setup lang="ts"></script>

<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_1691_7765)">
      <path
        d="M21 4V18.721C21.0001 18.818 20.972 18.913 20.9191 18.9943C20.8662 19.0756 20.7908 19.1398 20.702 19.179L12 23.03L3.298 19.18C3.20894 19.1407 3.13329 19.0762 3.08035 18.9945C3.02742 18.9128 2.99949 18.8174 3 18.72V4H1V2H23V4H21ZM8 12V14H16V12H8ZM8 8V10H16V8H8Z"
        fill="#0058AA"
      />
    </g>
    <defs>
      <clipPath id="clip0_1691_7765">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss"></style>
